var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"d-flex flex-column flex-nowrap pa-0 ma-0",staticStyle:{"height":"100%"},attrs:{"dark":""}},[_c(_vm.comp,{tag:"component",class:[_vm.shown ? 'fadein' : 'fadeout' ],on:{"completed":_vm.OnCompleted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }